import ConfirmationModal from "../ConfirmationModal";
import { ConfirmationModalProps } from "../ConfirmationModal/types";
import { ConfirmationModalMessage } from "../ConfirmationModal/Message";

type LeaveConfirmationModalProps = Pick<
  ConfirmationModalProps,
  | "onConfirm"
  | "isLoading"
  | "isDismissable"
  | "confirmationButtonLabel"
  | "title"
  | "children"
>;

const LeaveConfirmationModal = ({
  confirmationButtonLabel = "Leave",
  children,
  ...rest
}: LeaveConfirmationModalProps) => {
  const content =
    typeof children === "string" ? (
      <ConfirmationModalMessage>{children}</ConfirmationModalMessage>
    ) : (
      children
    );

  return (
    <ConfirmationModal confirmationButtonLabel={confirmationButtonLabel} {...rest}>
      {content}
    </ConfirmationModal>
  );
};

LeaveConfirmationModal.displayName = "DS.LeaveConfirmationModal";

export default LeaveConfirmationModal;
